import $ from 'jquery';

function extend(o, n, override) {
  for (var key in n) {
    if (n.hasOwnProperty(key) && (!o.hasOwnProperty(key) || override)) {
      o[key] = n[key];
    }
  }
  return o;
}

function Keychoose(opt) {
  this.init(opt);
}

Keychoose.prototype = {
  init: function(opt) {
    var def = {
      index: 0
    };
    this.def = extend(def, opt, true);
    this.choosebgColor(this.def.index);
  },
  next: function() {
    if (this.def.index < $(this.def.class).length - 1) {
      this.clearbgColor();
      this.def.index++;
      this.choosebgColor(this.def.index);
    }
  },
  prev: function() {
    if (this.def.index > 0) {
      this.clearbgColor();
      this.def.index--;
      this.choosebgColor(this.def.index);
    }
  },
  choosebgColor: function(index) {
    $(this.def.class).eq(index).css('background', 'rgba(0,0,0,0.2)');
  },
  clearbgColor: function() {
    $(this.def.class).css('background', '');
  },
  getIndex: function() {
    return this.def.index;
  }

};

export default Keychoose;
